export default class VanillaSmoothScroll {
  constructor(duration = 500, headerSelector = null) {
    this.duration = duration;
    this.headerSelector = headerSelector;
    this.links = document.querySelectorAll('a[href^="#"]');
    this.handleClick = this.handleClick.bind(this);
    this.init();
  }
  init() {
    if (!this.links.length) return;
    this.links.forEach((link) =>
      link.addEventListener("click", this.handleClick, { passive: false }),
    );
  }
  handleClick(e) {
    const href = e.currentTarget.getAttribute("href");
    if (!href || href === "#" || !href.startsWith("#")) return;
    const target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    const startY = window.pageYOffset;
    const targetY = this.getTargetPosition(target);
    const diff = targetY - startY;
    const startTime = performance.now();
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      window.scrollTo(0, targetY);
      return;
    }
    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      const eased =
        progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      window.scrollTo(0, startY + diff * eased);
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }
  getTargetPosition(target) {
    return (
      target.getBoundingClientRect().top +
      window.pageYOffset -
      this.getHeaderHeight()
    );
  }
  getHeaderHeight() {
    if (!this.headerSelector) return 0;
    const header = document.querySelector(this.headerSelector);
    return header ? header.offsetHeight : 0;
  }
}
